var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _c("the-loading-overlay", { attrs: { value: _vm.loading } }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: _vm.$vuetify.breakpoint.smAndDown,
            persistent: "",
            maxWidth: "1200"
          },
          model: {
            value: _vm.showTermsDialog,
            callback: function($$v) {
              _vm.showTermsDialog = $$v
            },
            expression: "showTermsDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "title justify-center" }, [
                _vm._v("Terms of Service")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                {
                  class: { "iframe-area": !_vm.$vuetify.breakpoint.smAndDown },
                  style: _vm.termsContentStyles
                },
                [
                  _c("iframe", {
                    staticClass: "terms",
                    attrs: { src: _vm.privacyPolicyUrl }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.acceptTerms()
                        }
                      }
                    },
                    [_vm._v("Accept")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("lightbox"),
      _vm._v(" "),
      _c("session-modal"),
      _vm._v(" "),
      _c("unauthorized-modal"),
      _vm._v(" "),
      !_vm.hideSidebar
        ? _c(
            "v-navigation-drawer",
            {
              attrs: { app: "", width: "240" },
              model: {
                value: _vm.isDrawerOpen,
                callback: function($$v) {
                  _vm.isDrawerOpen = $$v
                },
                expression: "isDrawerOpen"
              }
            },
            [
              _c(
                "v-list",
                { staticClass: "py-0" },
                [
                  _vm.isDrawerOpen && _vm.$vuetify.breakpoint.smAndDown
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { top: "5px", right: "5px" },
                          style: {
                            "background-color": _vm.themeAccent,
                            color: _vm.themeWhite
                          },
                          attrs: {
                            top: "",
                            right: "",
                            small: "",
                            absolute: "",
                            fab: ""
                          },
                          on: { click: _vm.closeDrawer }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "logo-background py-0 justify-center",
                      style: { "background-color": _vm.themePrimary }
                    },
                    [
                      _c("img", {
                        staticClass: "logo align-center",
                        attrs: { height: "90", src: _vm.siteCornerImage }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _vm.isLoadboardEnabled
                    ? _c(
                        "v-list-tile",
                        { attrs: { ripple: "", accent: "", to: "/" } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("search")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "Search " +
                                    _vm._s(_vm.$t("components.loadboard"))
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.signedIn && !_vm.isNonceUser
                    ? _c(
                        "v-list-tile",
                        {
                          staticClass: "new-load-tile",
                          attrs: { ripple: "", to: "/post-load" }
                        },
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c(
                                "v-btn",
                                {
                                  style: {
                                    "background-color": _vm.themeAccent,
                                    color: _vm.themeWhite
                                  },
                                  attrs: { small: "", fab: "" }
                                },
                                [_c("v-icon", [_vm._v("add")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [_c("v-list-tile-title", [_vm._v("Add New Load")])],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.userProfile.driverProfile
                    ? _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c(
                            "v-list-tile",
                            {
                              staticClass: "list-hotfix",
                              attrs: {
                                slot: "activator",
                                ripple: "",
                                to: "/my-loads"
                              },
                              slot: "activator"
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("assignment_ind")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("My Assigned Loads")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.signedIn
                    ? _c(
                        "v-layout",
                        { staticClass: "pa-0 ma-0", attrs: { column: "" } },
                        [
                          _vm.signedIn && !_vm.isNonceUser
                            ? _c(
                                "v-menu",
                                [
                                  _c("v-text-field", {
                                    staticClass: "pl-3 pr-2",
                                    attrs: {
                                      slot: "activator",
                                      label: _vm._.get(
                                        _vm.selectedCompany,
                                        "companyDisplayName",
                                        "select"
                                      ),
                                      "prepend-icon": "business",
                                      "append-icon": "arrow_drop_down",
                                      readonly: "",
                                      placeholder: "Company Dashboard"
                                    },
                                    slot: "activator"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    _vm._l(
                                      _vm.userProfile.companyAccounts,
                                      function(companyAccount) {
                                        return _vm.selectedDashboardCompanyId !==
                                          companyAccount.companyId ||
                                          _vm.userProfile.companyAccounts
                                            .length == 1
                                          ? _c(
                                              "v-list-tile",
                                              {
                                                key:
                                                  "companyAccountSelector-" +
                                                  companyAccount.companyId,
                                                on: {
                                                  click: function($event) {
                                                    return _vm.switchOrganizations(
                                                      companyAccount.companyId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-tile-title", [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        companyAccount.companyDisplayName
                                                      ) +
                                                      "\n              "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isNonceUser
                            ? _c(
                                "v-list-tile",
                                [
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "Welcome, " +
                                        _vm._s(_vm.userProfile.name) +
                                        ". Enjoy your visit."
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedCompany && _vm.selectedCompany.options
                            ? _c(
                                "v-list",
                                _vm._l(_vm.selectedCompany.options, function(
                                  option
                                ) {
                                  return _vm.selectedDashboardCompanyId
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          key: option.title,
                                          attrs: {
                                            ripple: "",
                                            to: option.link
                                          },
                                          on: { click: _vm.closeDrawer }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c("v-icon", [
                                                _vm._v(_vm._s(option.icon))
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(_vm._s(option.title))
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLtnAdmin ? _c("v-divider") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _vm.isLtnAdmin
                        ? _c(
                            "v-list",
                            [
                              _c(
                                "v-list-tile",
                                { staticClass: "list-hotfix" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "pt-4",
                                    attrs: {
                                      label: "LTN Admin",
                                      "prepend-icon": "apps",
                                      readonly: "",
                                      placeholder: "Admin Tools"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                {
                                  staticClass: "cursor-pointer list-hotfix",
                                  attrs: { ripple: "", to: "/companies/new" }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [_c("v-icon", [_vm._v("add_circle")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("New Company")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                {
                                  staticClass: "cursor-pointer list-hotfix",
                                  attrs: { ripple: "", to: "/companies" }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [_c("v-icon", [_vm._v("business")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("All Companies")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                {
                                  staticClass: "cursor-pointer list-hotfix",
                                  attrs: { ripple: "", to: "/untethered" }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [_c("v-icon", [_vm._v("gps_fixed")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v("Untethered Listings")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                {
                                  staticClass: "cursor-pointer list-hotfix",
                                  attrs: { ripple: "", to: "/users" }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [_c("v-icon", [_vm._v("people")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [_vm._v("Users")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _vm.signedIn
                    ? [
                        !_vm.isNonceUser
                          ? _c(
                              "v-layout",
                              {
                                staticClass: "py-3 primary cursor-pointer",
                                attrs: { row: "", "align-center": "" },
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push({ name: "profile" })
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { staticClass: "ml-2", attrs: { sm2: "" } },
                                  [
                                    _c(
                                      "v-avatar",
                                      { attrs: { size: "30" } },
                                      [
                                        _c("v-icon", [_vm._v("account_circle")])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "white--text",
                                    attrs: { sm10: "" }
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userProfile.name ||
                                            _vm.userProfile.contactEmail
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isNonceUser
                          ? _c(
                              "v-layout",
                              {
                                staticClass: "primary px-2 pb-3",
                                attrs: { row: "", "align-center": "" }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { sm2: "" } },
                                  [_c("v-icon", [_vm._v("settings")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "white--text cursor-pointer",
                                    attrs: { sm10: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.$router.push({
                                          name: "notification-settings"
                                        })
                                      }
                                    }
                                  },
                                  [_c("b", [_vm._v("Notification Settings")])]
                                ),
                                _vm._v(" "),
                                _c("v-spacer")
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            staticClass: "primary px-2 pb-1 cursor-pointer",
                            attrs: { row: "", "align-center": "" },
                            on: {
                              click: function($event) {
                                return _vm.signOut()
                              }
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { sm2: "" } },
                              [_c("v-icon", [_vm._v("exit_to_app")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "white--text",
                                attrs: { sm10: "" }
                              },
                              [_c("b", [_vm._v("Logout")])]
                            ),
                            _vm._v(" "),
                            _c("v-spacer")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.signedIn
                          ? _c(
                              "v-list-tile",
                              {
                                attrs: { ripple: "", accent: "", to: "/refer" }
                              },
                              [
                                _c(
                                  "v-list-tile-action",
                                  [_c("v-icon", [_vm._v("person_add")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v("Refer a Friend")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-list-tile",
                          {
                            attrs: {
                              ripple: "",
                              accent: "",
                              target: "_blank",
                              href: _vm.contactUsLink
                            }
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              [_c("v-icon", [_vm._v("contact_support")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                _c("v-list-tile-title", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.contact-us.label")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : [
                        _c(
                          "v-layout",
                          { staticClass: "white--text primary py-3 px-2" },
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "cursor-pointer",
                                on: { click: _vm.signIn }
                              },
                              [_c("b", [_vm._v("Log In")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push({ name: "onboard" })
                                  }
                                }
                              },
                              [_c("b", [_vm._v("Sign Up")])]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-tile",
                          {
                            attrs: {
                              ripple: "",
                              accent: "",
                              target: "_blank",
                              href: _vm.contactUsLink
                            }
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              [_c("v-icon", [_vm._v("contact_support")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                _c("v-list-tile-title", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("components.contact-us.label")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-content",
        [
          _c(
            "v-snackbar",
            {
              attrs: {
                value: _vm.notification.show,
                type: _vm.notification.type,
                timeout: _vm.notification.timeout,
                top: "",
                color: _vm.notification.color
              },
              model: {
                value: _vm.notificationStatus,
                callback: function($$v) {
                  _vm.notificationStatus = $$v
                },
                expression: "notificationStatus"
              }
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.notification.message) + "\n      "
              ),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.$store.dispatch(
                        "applications/hideNotification"
                      )
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            { staticClass: "pb-0", attrs: { fluid: "" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 